<template>
  <div class="q-full-container">
    <div v-if="badQuestions.includes(question.q_id)" style="color: red;">
      * Respuesta incorrecta
    </div>
    <div v-if="question.q_type === 'Open'">
      <open-question
        :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"></open-question>
    </div>
    <div v-if="question.q_type === 'RegularExpression'">
      <regular-expression-question
        :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"></regular-expression-question>
    </div>
    <div v-if="question.q_type === 'DPI'">
      <dpi-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"></dpi-question>
    </div>
    <div v-if="question.q_type === 'Options'">
      <options-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </options-question>
    </div>
    <div v-if="question.q_type === 'Gender'">
      <options-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </options-question>
    </div>
    <div v-if="question.q_type === 'State'">
      <options-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </options-question>
    </div>
    <div v-if="question.q_type === 'Yes/No'">
      <options-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </options-question>
    </div>
    <div v-if="question.q_type === 'Age'">
      <age-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion">
      </age-question>
    </div>
    <div v-if="question.q_type === 'IMEI'">
      <imei-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </imei-question>
    </div>
    <div v-if="question.q_type === 'PhoneNumber'">
      <phone-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </phone-question>
    </div>
    <div v-if="question.q_type === 'DisplayImage'">
      <image-question :question="question" :surveyIdProp="resultId"> </image-question>
    </div>
    <div v-if="question.q_type === 'MultipleOptions'">
      <multiple-options-question :question="question" :answerProp="question.list_ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </multiple-options-question>
    </div>
     <div v-if="question.q_type === 'NPS'">
      <nps-question :question="question" :answerProp="question.ans" @emit-value="emitValueQuestion"> </nps-question>
    </div>
    <div v-if="question.q_type === 'NPSTigo'">
      <nps-tigo-question :question="question" :answerProp="question.ans" @emit-value="emitValueQuestion"> </nps-tigo-question>
    </div>
    <div v-if="question.q_type === 'NPSBA'">
      <nps-ba-question :question="question" :answerProp="question.ans" @emit-value="emitValueQuestion"> </nps-ba-question>
    </div>
    <div v-if="question.q_type === 'QR'">
      <qr-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </qr-question>
    </div>
    <div v-if="question.q_type === 'UploadFile'">
      <file-image-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </file-image-question>
    </div>
    <div v-if="question.q_type === 'Location'">
      <location-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </location-question>
    </div>
    <div v-if="question.q_type === 'SelectionMatrix'">
      <selection-matrix-question :question="question" :answerProp="question.ans" :readOnly="readOnly" @emit-value="emitValueQuestion"> </selection-matrix-question>
    </div>
  </div>
</template>

<script>
import OpenQuestion from '@/views/Surveys/OpenQuestion.vue';
import RegularExpressionQuestion from '@/views/Surveys/RegularExpressionQuestion.vue';
import OptionsQuestion from '@/views/Surveys/OptionsQuestion.vue';
import AgeQuestion from '@/views/Surveys/AgeQuestion.vue';
import ImeiQuestion from '@/views/Surveys/IMEIQuestion.vue';
import DpiQuestion from '@/views/Surveys/DPIQuestion.vue';
import PhoneQuestion from '@/views/Surveys/PhoneQuestion.vue';
import ImageQuestion from '@/views/Surveys/ImageQuestion.vue';
import MultipleOptionsQuestion from '@/views/Surveys/MultipleOptionsQuestion.vue';
import NpsQuestion from '@/views/Surveys/NPSQuestion.vue';
import NpsTigoQuestion from '@/views/Surveys/NPSTigoQuestion.vue';
import NpsBaQuestion from '@/views/Surveys/NPSBAQuestion.vue';
import QrQuestion from '@/views/Surveys/QRQuestion.vue';
import FileImageQuestion from '@/views/Surveys/FileImageQuestion.vue';
import LocationQuestion from '@/views/Surveys/LocationQuestion.vue';
import SelectionMatrixQuestion from '@/views/Surveys/SelectionMatrixQuestion.vue';

export default {
  name: "question",
  components: {
    OpenQuestion,
    OptionsQuestion,
    AgeQuestion,
    ImeiQuestion,
    PhoneQuestion,
    ImageQuestion,
    MultipleOptionsQuestion,
    DpiQuestion,
    NpsQuestion,
    NpsTigoQuestion,
    NpsBaQuestion,
    QrQuestion,
    FileImageQuestion,
    LocationQuestion,
    RegularExpressionQuestion,
    SelectionMatrixQuestion
  },
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    badQuestions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    readOnly:{
      type: Boolean,
      default: false
    },
    resultId:{
      type: String,
      default: ""
    }
  },
  methods: {
    emitValueQuestion: function(e) {
      //console.log(e);
      this.$emit("emit-value-question", e);
    }
  }
};
</script>
